import React from 'react';
import TableChecklist from 'components/TableChecklist';

export function formatLocation(locationPos, container) {
  if (!container?.position_unraveled || !container?.num_cols)
    return locationPos

  const zeroBasedPosition = locationPos - 1
  const row = Math.floor(zeroBasedPosition / container.num_cols)
  const column = zeroBasedPosition % container.num_cols + 1
  if (container.position_rows_lettered)
  {
    const rowLabel = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[row]
    return `${locationPos} (${rowLabel}${column})`
  }
  else
    return `${locationPos} (${row + 1},${column})`
}

export default function RetrieveStep({rows, ...props}) {
  return (
    <TableChecklist
      size="small"
      columns={[
        {header: "Name", props: {component: "th", scope: "row"}},
        {header: "Box"},
        {header: "Position"},
        {header: "Description"},
      ]}
      rows={rows.map( row => [row?.name, row?.container?.name, formatLocation(row?.location_pos, row?.container), row?.description || (row?.concentration && `${row.concentration.value}${row.concentration.unit}`) || ""] )}
      {...props}
    />
  )
}
